import { HStack } from '@/ui/core/stack'
import { Image } from 'expo-image'
import { Pressable } from 'react-native'
import Images from '#/assets/images/image-map'

const GOOGLE_PLAY_URL =
	'https://play.google.com/store/apps/details?id=com.hiwally.patient_app&hl=en_US'
const APP_STORE_URL = 'https://apps.apple.com/us/app/wally-health/id6480306308'

const AppStoreLinks = () => {
	const navigateToGooglePlay = () => window.open(GOOGLE_PLAY_URL, '_blank')
	const navigateToAppleAppStore = () => window.open(APP_STORE_URL, '_blank')

	return (
		<HStack className="flex w-full justify-center gap-2 lg:px-0">
			<Pressable onPress={navigateToAppleAppStore}>
				<Image
					style={{
						height: 48,
						aspectRatio: 3.5,
					}}
					source={Images.AppStoreButton}
					contentFit="contain"
				/>
			</Pressable>
			<Pressable onPress={navigateToGooglePlay}>
				<Image
					style={{
						height: 48,
						aspectRatio: 3.5,
					}}
					source={Images.PlayStoreButton}
					contentFit="contain"
				/>
			</Pressable>
		</HStack>
	)
}

export { AppStoreLinks }
